import { useState } from 'react'
import moment from 'moment';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { getDataRangeByWeekNo } from '../../../../Services/utils';
import { IAllDistrictEAdhigamData, IAllSchoolEAdhigamData, IDetailedEAdhigamStudent, IDetailedStudentUsage, IDetailedTeacherUsage, IEAdhigamTeacherDetails, IOverviewEAdhigam, IOverviewStudentStrength, ISelectedFiltersUsingName, ITeacherOnStudentMonitoring } from '../../../../types';
import { getBlockWiseEAdhigam, getDetailedEAdhigamStudent, getDetailedStudentUsage, getDetailedTeacherUsage, getDistrictWiseEAdhigam, getOverviewEAdhigam, getOverviewStudentStrength, getOverviewTeacherOneHomework, getSchoolWiseEAdhigam, getStudentTeacherStrength, getTeacherMonitoring } from '../../../../Services/NewStats/StateOverViewAPIs';
import { DefaultEAdhigamTeacher, DefaultTeacherOnStudentMonitoring, defALlSchoolEAdhigamForProgress, defAllBlockEAdhigamForProgress, defaultDetailedEAdhigamStudent, defaultDetailedStudent, defaultDetailedTeacher, defaultOverviewEAdhigam } from '../DefaultValues';
import { State } from '../../../../Reducers/types';


export function useProgressReport() {

  const { filter } = useSelector((state: State) => state);

  const [selectedFilterForReport, setSelectedFilterForReport] = useState<ISelectedFiltersUsingName>();
  const [overviewEAdhigam, setOverviewEAdhigam] = useState<IOverviewEAdhigam>(defaultOverviewEAdhigam)
  const [detailedTeacherUsage, setDetailedTeacherUsage] = useState<IDetailedTeacherUsage>(defaultDetailedTeacher);
  const [detailedStudentUsage, setDetailedStudentUsage] = useState<IDetailedStudentUsage>(defaultDetailedStudent);
  const [allDistrictEAdhigam, setAllDistrictEAdhigam] = useState<IAllDistrictEAdhigamData[]>([])
  const [allBlockEAdhigam, setAllBlockEAdhigam] = useState<any[]>(defAllBlockEAdhigamForProgress)
  const [allSchoolEAdhigam, setAllSchoolEAdhigam] = useState<IAllSchoolEAdhigamData[]>(defALlSchoolEAdhigamForProgress)
  const [overviewTeacherAtLeastOneHomework, setOverviewTeacherAtLeastOneHomework] = useState<{ teacher_who_have_atleast_assessment: number }>({ teacher_who_have_atleast_assessment: 0 })
  const [overviewStudentStrength, setOverviewStudentStrength] = useState<IOverviewStudentStrength>({
    students_who_have_assigned_atleast_1_diagnostic_test: 0,
    Total_students_Strength: 0
  });

  const [overAllStudentStrength, setOverAllStudentStrength] = useState<{ "overall": number, "10": number, "11": number, "12": number }>({ "overall": null, "10": null, "11": null, "12": null })
  const [teacherEAdhigamTeacherDetails, setTeacherEAdhigamTeacherDetails] = useState<IEAdhigamTeacherDetails>(DefaultEAdhigamTeacher)
  const [detailedEAdhigamStudent, setDetailedEAdhigamStudent] = useState<IDetailedEAdhigamStudent>(defaultDetailedEAdhigamStudent)
  const [teacherOnStudentMonitoring, setTeacherOnStudentMonitoring] = useState<ITeacherOnStudentMonitoring>(DefaultTeacherOnStudentMonitoring)

  const [promisesResolve, setPromiseResolve] = useState<number>(11);

  // TODO : change the week to current-1
  const weeKForAPi = (moment().week() - 1) //37
  const weekNo = moment().week()
  let weekDate =
  {
    firstWeekDate: getDataRangeByWeekNo(weekNo - 1),
    secondWeekDate: getDataRangeByWeekNo(weekNo - 2),
    thirdWeekDate: getDataRangeByWeekNo(weekNo - 3),
    forthWeekDate: getDataRangeByWeekNo(weekNo - 4)
  }

  // useEffect(() => {
  //   // setPromiseResolve(0)
  //   // fetchOverviewEAdhigam()
  //   // fetchOverviewTeacherStrength()
  //   // fetchDetailedTeacher()
  //   // fetchDetailedStudent()
  //   // fetchDetailedEAdhigamStudent()
  //   // handleDistictBlockWiseEAdhigam()
  // }, [selectedFilterForReport])


  // HAndler function  

  const handleOnSearch = () => {
    setPromiseResolve(0)
    fetchOverviewEAdhigam()
    fetchOverviewTeacherAtLeastOneHomework()
    fetchOverviewTeacherStrength()
    fetchDetailedTeacher()
    fetchDetailedStudent()
    fetchDetailedEAdhigamStudent()
    fetchDistrictBlockWiseEAdhigam()
    fetchStudentStrength()
    fetchTeacherMonitoring()
  };

  const countOverAllAvg = (classes: any) => {
    if (classes) {
      let data = Object.values(classes);
      let sum = 0;
      data.forEach((e: any) => {
        sum += Number(e);
      });

      const overallStrength = overAllStudentStrength?.overall;

      if (!overallStrength || overallStrength === 0) {
        return 0; // Return "0" if overallStrength is undefined or 0 to avoid division by zero
      }

      let result = sum / overallStrength;

      if (Number.isInteger(result)) {
        return result;
      } else {
        return result;
      }
    } else {
      return 0;
    }
  };


  const countOverAllSum = (values: any) => {
    if (values) {
      let data = Object.values(values)
      let sum = 0;
      data.map((e) => {
        sum = sum + Number(e)
      })
      let result = sum ?? 0;
      return result
    }
    else {
      return 0
    }
  };

  const countAveragePerUser = (value: any, totalUser: "10" | "11" | "12") => {
    let divisor;

    if (totalUser === "10") {
      divisor = overAllStudentStrength?.[10];
    } else if (totalUser === "11") {
      divisor = overAllStudentStrength?.[11];
    } else if (totalUser === "12") {
      divisor = overAllStudentStrength?.[12];
    }

    if (!divisor || divisor === 0) {
      return 0; // Return 0 if divisor is undefined or 0 to avoid division by zero
    }

    const res = +value / +divisor;
    const result = res ?? 0
    return result
  };

  const countPercentage = (value, totalValue) => {
    if (value && totalValue) {
      let percent = (Number(value) / Number(totalValue)) * 100
      return percent ? `${value} ( ${percent.toFixed(2)} %)` : `0.00 %`
    }
    else {
      return "0"
    }
  };

  // API REQUESTS

  const fetchOverviewEAdhigam = async () => {
    setOverviewEAdhigam(defaultOverviewEAdhigam)
    const res = await getOverviewEAdhigam(
      selectedFilterForReport?.districtId || "-1",
      selectedFilterForReport?.blockId || "-1",
      selectedFilterForReport?.schoolId || "-1",
      selectedFilterForReport?.week_no || weeKForAPi,
      filter.year
    ).then((res) => {
      console.log(res?.data)
      if (res?.data?.Is_Success) {
        setOverviewEAdhigam(res.data?.response)
      }
      else {
        toast.error("could not fetch overview e-Adhigam data")
      }
    }).catch((err) => toast.error("could not fetch overview e-Adhigam data"))
      .finally(() => setPromiseResolve((prev) => prev + 1))
  };

  const fetchOverviewTeacherAtLeastOneHomework = async () => {
    setOverviewTeacherAtLeastOneHomework({ teacher_who_have_atleast_assessment: 0 })
    const res = await getOverviewTeacherOneHomework(
      selectedFilterForReport?.districtId || "-1",
      selectedFilterForReport?.blockId || "-1",
      selectedFilterForReport?.schoolId || "-1",
      selectedFilterForReport?.week_no || weeKForAPi,
      filter.year
    ).then((res) => {
      if (res?.data?.Is_Success) {
        setOverviewTeacherAtLeastOneHomework(res.data?.response)
      }
      else {
        toast.error("could not fetch overview e-Adhigam data")
      }
    }).catch((err) => toast.error("could not fetch overview e-Adhigam data"))
      .finally(() => setPromiseResolve((prev) => prev + 1))
  };

  const fetchStudentStrength = async () => {
    setOverAllStudentStrength({ overall: 0, "10": 0, "11": 0, "12": 0 })
    setTeacherEAdhigamTeacherDetails(DefaultEAdhigamTeacher)
    const res = await getStudentTeacherStrength(
      selectedFilterForReport?.districtId || "-1",
      selectedFilterForReport?.blockId || "-1",
      selectedFilterForReport?.schoolId || "-1",
      selectedFilterForReport?.week_no || weeKForAPi,
      filter.year
    ).then((res) => {
      if (res?.data?.Is_Success) {
        setOverAllStudentStrength({ overall: (Number(res?.data?.response?.Total_students_Strength_group?.[10]) + Number(res?.data?.response?.Total_students_Strength_group?.[11]) + Number(res?.data?.response?.Total_students_Strength_group?.[12])), "10": Number(res?.data?.response?.Total_students_Strength_group?.[10]), "11": Number(res?.data?.response?.Total_students_Strength_group?.[11]), "12": +res?.data?.response?.Total_students_Strength_group?.[12] })
        setTeacherEAdhigamTeacherDetails(res?.data?.response?.teacher)
      }
      else {
        toast.error("could not fetch student strength and e-adhigam teacher detail data")
      }
    }).catch((err) => toast.error("could not fetch Student strength data"))
      .finally(() => setPromiseResolve((prev) => prev + 1))
  }


  const fetchTeacherMonitoring = async () => {
    setTeacherOnStudentMonitoring(DefaultTeacherOnStudentMonitoring)
    const res = await getTeacherMonitoring(
      selectedFilterForReport?.districtId || "-1",
      selectedFilterForReport?.blockId || "-1",
      selectedFilterForReport?.schoolId || "-1",
      selectedFilterForReport?.week_no || weeKForAPi,
      filter.year
    ).then((res) => {
      if (res?.data?.Is_Success) {
        setTeacherOnStudentMonitoring(res?.data?.response)
      }
      else {
        toast.error("could not fetch student strength and e-adhigam teacher detail data")
      }
    }).catch((err) => toast.error("could not fetch Student strength data"))
      .finally(() => setPromiseResolve((prev) => prev + 1))
  }


  const fetchOverviewTeacherStrength = async () => {
    setOverviewStudentStrength({
      students_who_have_assigned_atleast_1_diagnostic_test: 0,
      Total_students_Strength: 0
    })
    const res = await getOverviewStudentStrength(
      selectedFilterForReport?.districtId || "-1",
      selectedFilterForReport?.blockId || "-1",
      selectedFilterForReport?.schoolId || "-1",
      selectedFilterForReport?.week_no || weeKForAPi,
      filter.year
    ).then((res) => {
      if (res?.data?.Is_Success) {
        setOverviewStudentStrength(res?.data?.response)
      }
      else {
        toast.error("Could not fetch overview teacher strength ")
      }
    }).catch((err) => toast.error("Could not fetch overview teacher strength "))
      .finally(() => setPromiseResolve((prev) => prev + 1))
  };


  const fetchDetailedTeacher = async () => {
    setDetailedTeacherUsage(defaultDetailedTeacher)
    getDetailedTeacherUsage(
      selectedFilterForReport?.districtId || "-1",
      selectedFilterForReport?.blockId || "-1",
      selectedFilterForReport?.schoolId || "-1",
      selectedFilterForReport?.week_no || weeKForAPi,
      filter.year
    ).then((res) => {
      if (res?.data?.Is_Success) {
        setDetailedTeacherUsage(res?.data?.response)
      }
      else {
        toast.error("Could not fetch teacher detail usage")
      }
    })
      .catch((err) => toast.error("Could not fetch teacher detail usage")
      ).finally(() => setPromiseResolve((prev) => prev + 1))
  };


  const fetchDetailedStudent = async () => {
    setDetailedStudentUsage(defaultDetailedStudent)
    const res = await getDetailedStudentUsage(
      selectedFilterForReport?.districtId || "-1",
      selectedFilterForReport?.blockId || "-1",
      selectedFilterForReport?.schoolId || "-1",
      selectedFilterForReport?.week_no || weeKForAPi,
      filter.year
    ).then((res) => {
      if (res?.data?.Is_Success) {
        setDetailedStudentUsage(res?.data?.response)
        // setOverAllStudentStrength({ overall: (Number(res?.data?.response?.Total_students_Strength_group?.[10]) + Number(res?.data?.response?.Total_students_Strength_group?.[11]) + Number(res?.data?.response?.Total_students_Strength_group?.[12])), "10": Number(res?.data?.response?.Total_students_Strength_group?.[10]), "11": Number(res?.data?.response?.Total_students_Strength_group?.[11]), "12": +res?.data?.response?.Total_students_Strength_group?.[12] })
      }
      else {
        toast.error("Could not fetch student detail usage")
      }
    }).catch(() => {
      toast.error("Could not fetch student detail usage")
    }).finally(() => setPromiseResolve((prev) => prev + 1))
  };


  const fetchDetailedEAdhigamStudent = async () => {
    setDetailedEAdhigamStudent(defaultDetailedEAdhigamStudent)
    const res = await getDetailedEAdhigamStudent(
      selectedFilterForReport?.districtId || "-1",
      selectedFilterForReport?.blockId || "-1",
      selectedFilterForReport?.schoolId || "-1",
      selectedFilterForReport?.week_no || weeKForAPi,
      filter.year
    ).then((res) => {
      if (res?.data?.Is_Success) {
        setDetailedEAdhigamStudent(res?.data?.response)
      }
      else {
        toast.error("Could not fetch e-Adhigam Student")
      }
    }).catch((err) => toast.error("Could not fetch e-Adhigam Student"))
      .finally(() => setPromiseResolve((prev) => prev + 1))
  };


  const fetchDistrictBlockWiseEAdhigam = async () => {
    if (!selectedFilterForReport?.districtId) {
      setAllBlockEAdhigam(undefined);
      setAllSchoolEAdhigam(undefined);
      await getDistrictWiseEAdhigam(weeKForAPi, filter.year).then((res) => {
        if (res?.data?.Is_Success) {
          setAllDistrictEAdhigam(res?.data?.response);
        }
        else {
          toast.error("Could not fetch all district e-Adhigam")
          setAllDistrictEAdhigam([]);
        }
      })
    };

    if (selectedFilterForReport?.districtId && !selectedFilterForReport?.blockId) {
      await getBlockWiseEAdhigam(
        selectedFilterForReport?.districtId,
        weeKForAPi,
        filter.year
      ).then((res) => {
        setAllDistrictEAdhigam([]);
        setAllSchoolEAdhigam(undefined);
        setAllBlockEAdhigam([])
        if (res?.data?.Is_Success) {
          setAllBlockEAdhigam(res?.data?.response);
        }
        else {
          toast.error("Could not fetch all district e-Adhigam")
          setAllBlockEAdhigam(defAllBlockEAdhigamForProgress)
        }
      })
    };

    if (selectedFilterForReport?.districtId && selectedFilterForReport?.blockId) {
      await getSchoolWiseEAdhigam(
        selectedFilterForReport?.districtId,
        selectedFilterForReport?.blockId,
        weeKForAPi,
        filter.year
      ).then((res) => {
        setAllDistrictEAdhigam([]);
        setAllSchoolEAdhigam([])
        setAllBlockEAdhigam(undefined);
        if (res?.data?.Is_Success) {
          setAllSchoolEAdhigam(res?.data?.response);
        }
        else {
          setAllSchoolEAdhigam(defALlSchoolEAdhigamForProgress)
          toast.error("Could not fetch all district e-Adhigam")
        }
      })
    }
  };


  return {
    weekNo,
    weekDate,
    selectedFilterForReport,
    setSelectedFilterForReport,
    handleOnSearch,
    overviewEAdhigam,
    overviewStudentStrength,
    overviewTeacherAtLeastOneHomework,
    detailedTeacherUsage,
    teacherOnStudentMonitoring,
    detailedStudentUsage,
    overAllStudentStrength,
    teacherEAdhigamTeacherDetails,
    countOverAllAvg,
    countOverAllSum,
    countPercentage,
    countAveragePerUser,
    detailedEAdhigamStudent,
    promisesResolve,
    setPromiseResolve,
    allDistrictEAdhigam,
    allBlockEAdhigam,
    allSchoolEAdhigam
  }
}
